import {
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  Grid,
  Modal,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { maskedTaxrefList, submitCaptureDetailsFormAsync, displayMaskedTaxrefModal, setDisplayMaskedTaxrefModal } from "../../features/BookingsSlice";
import { setCaptchaSubmissionStarted, setDetailsCaptured } from "../../features/CaptureDetailsSlice";
import { useForm } from "react-final-form";

const MaskedTaxRefSelectModal = () => {
  const dispatch = useDispatch();
  const displayModal = useSelector(displayMaskedTaxrefModal);
  const handleOpen = () => dispatch(setDisplayMaskedTaxrefModal(true));
  const handleClose = () => {
    dispatch(setCaptchaSubmissionStarted(false));
    dispatch(setDetailsCaptured(false));
    dispatch(setDisplayMaskedTaxrefModal(false))
  };
  const requesterDetailsForm = useForm()

  const style = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    padding: "0px",
  };

  const taxNumberStyle = {
    paddingTop: "8px",
    paddingLeft: "16px"
  };

  const taxrefList = useSelector(maskedTaxrefList);
  const [selectedNumber, setSelectedNumber] = useState('');

  const handleSelect = (event: { target: { value: string; }; }) => {
    const taxrefno = event.target.value as string;
    setSelectedNumber(taxrefno);
  };

  const submitTaxref = () => {
    requesterDetailsForm.change("taxNumber", selectedNumber);
    requesterDetailsForm.change("taxpayer_TRN", selectedNumber);
    dispatch(submitCaptureDetailsFormAsync());
  }

  return (
    <Modal
      open={displayModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Card>
          <CardHeader title="Select your tax reference number:" subheader="" />
          {taxrefList &&
            taxrefList.map((number, index) => (
              <div key={index} style={taxNumberStyle}>
                <input
                  type="radio"
                  id={number}
                  name="number"
                  value={number}
                  checked={selectedNumber === number}
                  onChange={handleSelect}
                />
                <label htmlFor={number}>{number}</label>
              </div>
            ))}
          <CardActions>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Button type="button" variant="contained" disabled={selectedNumber === ''}  onClick={submitTaxref}>
                  Confirm
                </Button>
              </Grid>
              <Grid item>
                <Button type="button" variant="outlined" onClick={handleClose}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Box>
    </Modal>
  );
};

export default MaskedTaxRefSelectModal;
